import React from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";

const PrivacyPolicy = () => {
  useDocTitle("ZelT | Privacy Policy");

  return (
    <div>
      <NavBar />
      <div className="mt-8 w-full bg-white py-12 lg:py-20">
        <div className="mx-4 max-w-3xl mx-auto">
          <h1 className="text-4xl font-extrabold text-blue-900 text-center mb-10">
            Privacy Policy
          </h1>
          <div className="space-y-8 text-gray-600 leading-relaxed">
            <p className="text-sm text-gray-400">
              Last updated: September 2026
            </p>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                Our Promise
              </h2>
              <p>
                ZelTechnology is a nonprofit. We collect the minimum
                information needed to provide our services, we never sell or
                rent your data, and we never will. This policy explains
                exactly what we collect and why.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                What We Collect
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <b>Account information:</b> a username, email address, and
                  password (stored only as a modern cryptographic hash — we
                  cannot see your password).
                </li>
                <li>
                  <b>Referral information (optional):</b> how you heard about
                  us, if you choose to tell us.
                </li>
                <li>
                  <b>Contact form submissions:</b> whatever you choose to send
                  us when requesting help.
                </li>
              </ul>
              <p className="mt-3">
                LAMNA (our AI chat) conversations are <b>never saved</b> — they
                exist only in your open browser and are destroyed when you
                leave the page.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                What We Don't Do
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>We do not sell, rent, or trade your personal information.</li>
                <li>We do not track you across other websites.</li>
                <li>We do not send marketing email you didn't sign up for.</li>
                <li>We do not store your passwords in readable form.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                Third-Party Services
              </h2>
              <p>
                We rely on a small number of reputable providers to operate:
                Google Workspace (email), our web hosting provider, and — if
                enabled — Google AdSense for advertising (see below). These
                providers may use cookies subject to their own privacy
                policies.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                Cookies and Advertising
              </h2>
              <p>
                We use a small number of essential cookies to keep you logged
                in securely. If third-party advertising (such as Google
                AdSense) is enabled on this site, those providers may use
                cookies to serve ads based on your prior visits. You can opt
                out of personalized advertising via{" "}
                <a
                  href="https://www.google.com/settings/ads"
                  className="text-blue-900 font-semibold underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Google Ads Settings
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                Your Rights
              </h2>
              <p>
                You may request a copy of your data, correction of your data,
                or deletion of your account at any time by emailing{" "}
                <b>support@zeltechnology.org</b>. We will honor requests
                promptly.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">Contact</h2>
              <p>
                ZelTechnology — #1055, 11160 Rancho Carmel Dr STE 106, San
                Diego, CA 92128 —{" "}
                <b>support@zeltechnology.org</b>
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
